// components/Apps/Quiz/MultipleChoiceAnswerOptions.js
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../Atoms';

const MultipleChoiceAnswerOptions = ({ choices, allowMultipleSelection, selectedAnswer, onAnswer }) => {
  const handleClick = (index) => {
    if (allowMultipleSelection) {
      const current = selectedAnswer || [];
      const newAnswer = current.includes(index)
        ? current.filter(i => i !== index)
        : [...current, index];
      onAnswer(newAnswer);
    } else {
      onAnswer(index);
    }
  };

  const isSelected = (index) => {
    if (allowMultipleSelection) return selectedAnswer?.includes(index);
    return selectedAnswer === index;
  };

  return (
    <div className="quiz-multiple-choice">
      {choices?.map((choice, index) => (
        <Button
          key={index}
          variant={isSelected(index) ? 'solid' : 'outline'}
          onClick={() => handleClick(index)}
          className="quiz-multiple-choice__option"
        >
          {choice}
        </Button>
      ))}
    </div>
  );
};

MultipleChoiceAnswerOptions.propTypes = {
  choices:               PropTypes.arrayOf(PropTypes.string),
  allowMultipleSelection: PropTypes.bool,
  selectedAnswer:        PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  onAnswer: PropTypes.func.isRequired,
};

export default MultipleChoiceAnswerOptions;